
import gql from "graphql-tag";

export default {
  publisherDetailsFragment: gql`
    fragment PublisherDetails on Publisher {
      id
      _id
      name
      slug
      description
      imageUrl
      websiteUrl
      twitterHandle
      instagramHandle
      tiktokHandle
      facebookHandle
      youtubeHandle
      createdAt
      updatedAt
    }
  `,
};
